<template>
  <div class="wc-sidebar d-flex flex-column" >
    <div class="wc-sb-header pt-4 px-4 pb-0">
      <div class="d-flex align-center justify-space-between mb-4">
        <div class="d-flex align-center" style="gap: 12px">
          <div class="wc-sb-icon-box" style="background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(0,0,0,0)); border: 1px solid rgba(76, 175, 80, 0.3);">
            <v-icon small color="green accent-3">mdi-view-dashboard-outline</v-icon>
          </div>
          <span class="wc-sb-title" style="font-size: 1.1rem; font-weight: 700; letter-spacing: 0.5px;">Vorlagen</span>
        </div>
        <div class="d-flex" style="gap: 8px">
          <v-btn icon @click="editMode = !editMode" :color="editMode ? 'primary' : ''" class="wc-sb-add" elevation="0" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1)">
            <v-icon small>{{ editMode ? 'mdi-check' : 'mdi-pencil-outline' }}</v-icon>
          </v-btn>
          <v-btn icon @click="$emit('create')" class="wc-sb-add" elevation="0" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1)">
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Premium Segmented Control (Horizontal Flex) -->
      <div class="wc-sb-premium-tabs mb-2 mt-2">
        <div class="wc-sb-tab" :class="{ active: activeTab === 0 }" @click="activeTab = 0">
          <v-icon small class="wc-sb-tab-icon">mdi-checkbox-marked-circle-outline</v-icon>
          <span class="wc-sb-tab-text">Ämtli</span>
        </div>
        <div class="wc-sb-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
          <v-icon small class="wc-sb-tab-icon">mdi-clipboard-text</v-icon>
          <span class="wc-sb-tab-text">Aufgabe</span>
        </div>
        <div class="wc-sb-tab" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
          <v-icon small class="wc-sb-tab-icon">mdi-calendar-star</v-icon>
          <span class="wc-sb-tab-text">Termin</span>
        </div>
        <div class="wc-sb-tab" :class="{ active: activeTab === 3 }" @click="activeTab = 3">
          <v-icon small class="wc-sb-tab-icon">mdi-account-clock</v-icon>
          <span class="wc-sb-tab-text">Info</span>
        </div>
      </div>
    </div>

    <div class="wc-sb-body custom-scrollbar flex-grow-1 pa-4 overflow-y-auto" style="min-height: 0;">
      
      <!-- TAB 0: ÄMTLI -->
      <div v-show="activeTab === 0">
        <!-- Tägliche Ämtli (Daily Tasks) -->
      <div class="wc-sb-section mb-8" v-if="dailyTasks.length > 0">
        <div class="text-overline mb-3 letter-spacing-1 px-1" style="color: #66bb6a; opacity: 0.9">Offene Ämtli (Heute)</div>
        <div
          v-for="tpl in dailyTasks"
          :key="tpl.id"
          class="wc-sb-card wc-sb-card-nodrag mb-2"
          :class="{ 'wc-sb-card-highlight': !tpl.isAssigned }"
          :style="{ '--card-color': tpl.isAssigned ? '#9e9e9e' : (tpl.color || '#4CAF50'), opacity: tpl.isAssigned ? 0.5 : 1, cursor: tpl.isAssigned ? 'default' : 'pointer' }"
          @click="!tpl.isAssigned && !editMode && $emit('task-assign', tpl)">
          <div class="wc-sb-card-icon" :style="{ background: tpl.isAssigned ? '#757575' : '' }">
            <v-icon small color="white">{{ tpl.isAssigned ? 'mdi-check-circle' : (tpl.icon || 'mdi-checkbox-marked') }}</v-icon>
          </div>
          <div class="wc-sb-card-content">
            <div class="wc-sb-card-title" :style="{ textDecoration: tpl.isAssigned ? 'line-through' : 'none' }">{{ tpl.title }}</div>
            <div class="wc-sb-card-meta font-weight-bold" :style="{ color: tpl.isAssigned ? 'rgba(255,255,255,0.4)' : '#66bb6a' }">
              <v-icon x-small :color="tpl.isAssigned ? 'rgba(255,255,255,0.4)' : '#66bb6a'" class="mr-1">mdi-clock-outline</v-icon>{{ tpl.time }}
            </div>
          </div>
        </div>
        </div>
        <div v-if="dailyTasks.length === 0" class="text-center mt-10 opacity-40">
          <v-icon large class="mb-3" color="rgba(255,255,255,0.3)">mdi-check-all</v-icon>
          <div style="font-size: 0.85rem">Alles erledigt für heute!</div>
        </div>
        
        <!-- Tägliche Aufgaben (Manuell / Ohne Zeitbindung) -->
        <div class="wc-sb-section mb-8 mt-6" v-if="dailyTaskTemplates.length > 0">
          <div class="text-overline mb-3 letter-spacing-1 px-1" style="color: #42a5f5; opacity: 0.8">Manuelle / Tägliche Ämtli</div>
          <div v-for="tpl in dailyTaskTemplates" :key="tpl._id || tpl.id" class="wc-sb-card wc-sb-card-nodrag mb-2" :style="{ '--card-color': tpl.color || '#2196F3', cursor: 'pointer' }" @click="!editMode && $emit('task-assign', tpl)">
            <div class="wc-sb-card-icon"><v-icon small color="white">{{ tpl.icon || 'mdi-checkbox-marked' }}</v-icon></div>
            <div class="wc-sb-card-content">
              <div class="wc-sb-card-title">{{ tpl.title }}</div>
              <div class="wc-sb-card-meta">Manuelles Ämtli</div>
            </div>
            <div v-if="editMode" class="d-flex" style="gap: 2px">
              <v-btn icon small color="blue lighten-1" @click.stop="$emit('edit-template', tpl)"><v-icon small>mdi-pencil</v-icon></v-btn>
              <v-btn icon small color="red lighten-1" @click.stop="$emit('delete-template', tpl._id || tpl.id)"><v-icon small>mdi-delete</v-icon></v-btn>
            </div>
          </div>
        </div>

        <!-- Wöchentliche Aufgaben -->
        <div class="wc-sb-section mb-8 mt-6" v-if="weeklyTaskTemplates.length > 0">
          <div class="text-overline mb-3 letter-spacing-1 px-1" style="color: #AB47BC; opacity: 0.8">Wöchentliche Ämtli</div>
          <div v-for="tpl in weeklyTaskTemplates" :key="tpl._id || tpl.id" class="wc-sb-card mb-2" :style="{ '--card-color': tpl.color || '#AB47BC', cursor: 'pointer', opacity: isTaskDone(tpl) ? 0.4 : 1 }" :draggable="!editMode" @dragstart="!editMode && onDragStart($event, tpl)" @dragend="dragging = null" @click="!editMode && $emit('task-assign', tpl)">
            <div class="wc-sb-card-icon"><v-icon small color="white">{{ tpl.icon || 'mdi-calendar-week' }}</v-icon></div>
            <div class="wc-sb-card-content">
              <div class="wc-sb-card-title" :style="{ textDecoration: isTaskDone(tpl) ? 'line-through' : 'none' }">{{ tpl.title }}</div>
              <div class="wc-sb-card-meta">{{ getTaskCountString(tpl, 'weekly') }}</div>
            </div>
            <v-icon v-if="!editMode" x-small class="wc-sb-card-drag">mdi-drag-variant</v-icon>
            <div v-if="editMode" class="d-flex" style="gap: 2px">
              <v-btn icon small color="blue lighten-1" @click.stop="$emit('edit-template', tpl)"><v-icon small>mdi-pencil</v-icon></v-btn>
              <v-btn icon small color="red lighten-1" @click.stop="$emit('delete-template', tpl._id || tpl.id)"><v-icon small>mdi-delete</v-icon></v-btn>
            </div>
          </div>
        </div>

        <!-- Monatliche Aufgaben -->
        <div class="wc-sb-section mb-8 mt-6" v-if="monthlyTaskTemplates.length > 0">
          <div class="text-overline mb-3 letter-spacing-1 px-1" style="color: #00897B; opacity: 0.8">Monatliche Ämtli</div>
          <div v-for="tpl in monthlyTaskTemplates" :key="tpl._id || tpl.id" class="wc-sb-card mb-2" :style="{ '--card-color': tpl.color || '#00897B', cursor: 'pointer', opacity: isTaskDone(tpl) ? 0.4 : 1 }" :draggable="!editMode" @dragstart="!editMode && onDragStart($event, tpl)" @dragend="dragging = null" @click="!editMode && $emit('task-assign', tpl)">
            <div class="wc-sb-card-icon"><v-icon small color="white">{{ tpl.icon || 'mdi-calendar-month' }}</v-icon></div>
            <div class="wc-sb-card-content">
              <div class="wc-sb-card-title" :style="{ textDecoration: isTaskDone(tpl) ? 'line-through' : 'none' }">{{ tpl.title }}</div>
              <div class="wc-sb-card-meta">{{ getTaskCountString(tpl, 'monthly') }}</div>
            </div>
            <v-icon v-if="!editMode" x-small class="wc-sb-card-drag">mdi-drag-variant</v-icon>
            <div v-if="editMode" class="d-flex" style="gap: 2px">
              <v-btn icon small color="blue lighten-1" @click.stop="$emit('edit-template', tpl)"><v-icon small>mdi-pencil</v-icon></v-btn>
              <v-btn icon small color="red lighten-1" @click.stop="$emit('delete-template', tpl._id || tpl.id)"><v-icon small>mdi-delete</v-icon></v-btn>
            </div>
          </div>
        </div>

      </div>

      </div>

      <!-- TAB 1: AUFGABE -->
      <div v-show="activeTab === 1">
        <div class="wc-sb-section mb-8 mt-4" v-if="taskTemplates.length > 0">
          <div class="text-overline mb-3 letter-spacing-1 px-1" style="color: #FF9800; opacity: 0.8">Aufgaben Vorlagen</div>
          <div v-for="tpl in taskTemplates" :key="tpl._id || tpl.id" class="wc-sb-card mb-2" :style="{ '--card-color': tpl.color || '#FF9800', cursor: 'pointer' }" :draggable="!editMode" @dragstart="!editMode && onDragStart($event, tpl)" @dragend="dragging = null">
            <div class="wc-sb-card-icon"><v-icon small color="white">{{ tpl.icon || 'mdi-clipboard-text' }}</v-icon></div>
            <div class="wc-sb-card-content">
              <div class="wc-sb-card-title">{{ tpl.title }}</div>
              <div class="wc-sb-card-meta">Aufgabe</div>
            </div>
            <v-icon v-if="!editMode" x-small class="wc-sb-card-drag">mdi-drag-variant</v-icon>
            <div v-if="editMode" class="d-flex" style="gap: 2px">
              <v-btn icon small color="blue lighten-1" @click.stop="$emit('edit-template', tpl)"><v-icon small>mdi-pencil</v-icon></v-btn>
              <v-btn icon small color="red lighten-1" @click.stop="$emit('delete-template', tpl._id || tpl.id)"><v-icon small>mdi-delete</v-icon></v-btn>
            </div>
          </div>
        </div>
        <div v-else class="text-center mt-10 opacity-40">
          <v-icon large class="mb-3" color="rgba(255,255,255,0.3)">mdi-clipboard-text</v-icon>
          <div style="font-size: 0.85rem">Keine Aufgaben Vorlagen.</div>
        </div>
      </div>

      <!-- TAB 2: TERMINE -->
      <div v-show="activeTab === 2">
        <div class="wc-sb-section mb-8">
        <div class="text-overline mb-3 letter-spacing-1 opacity-60 px-1">Trainings & Checkups</div>
        <div
          v-for="tpl in trainingTemplates"
          :key="tpl.id"
          class="wc-sb-card mb-2"
          :style="{ '--card-color': tpl.color }"
          :draggable="!editMode"
          @dragstart="!editMode && onDragStart($event, tpl)"
          @dragend="dragging = null"
          @click="!editMode && $emit('template-click', tpl)">
          <div class="wc-sb-card-icon">
            <v-icon small color="white">{{ tpl.icon }}</v-icon>
          </div>
          <div class="wc-sb-card-content">
            <div class="wc-sb-card-title">{{ tpl.title }}</div>
            <div class="wc-sb-card-meta">{{ tpl.duration }} Min.</div>
          </div>
          <v-icon v-if="!editMode" x-small class="wc-sb-card-drag">mdi-drag-variant</v-icon>
        </div>
      </div>

      <div class="wc-sb-section mb-8">
        <div class="text-overline mb-3 letter-spacing-1 opacity-60 px-1">Verträge & Management</div>
        <div
          v-for="tpl in contractTemplates"
          :key="tpl.id"
          class="wc-sb-card mb-2"
          :style="{ '--card-color': tpl.color }"
          :draggable="!editMode"
          @dragstart="!editMode && onDragStart($event, tpl)"
          @dragend="dragging = null"
          @click="!editMode && $emit('template-click', tpl)">
          <div class="wc-sb-card-icon">
            <v-icon small color="white">{{ tpl.icon }}</v-icon>
          </div>
          <div class="wc-sb-card-content">
            <div class="wc-sb-card-title">{{ tpl.title }}</div>
            <div class="wc-sb-card-meta">Aktion</div>
          </div>
          <v-icon v-if="!editMode" x-small class="wc-sb-card-drag">mdi-drag-variant</v-icon>
        </div>
      </div>

      <div class="wc-sb-section mb-8">
        <div class="text-overline mb-3 letter-spacing-1 opacity-60 px-1">Termine</div>
        <div
          v-for="tpl in standardAppointmentTemplates"
          :key="tpl.id"
          class="wc-sb-card mb-2"
          :style="{ '--card-color': tpl.color }"
          :draggable="!editMode"
          @dragstart="!editMode && onDragStart($event, tpl)"
          @dragend="dragging = null"
          @click="!editMode && $emit('template-click', tpl)">
          <div class="wc-sb-card-icon">
            <v-icon small color="white">{{ tpl.icon }}</v-icon>
          </div>
          <div class="wc-sb-card-content">
            <div class="wc-sb-card-title">{{ tpl.title }}</div>
            <div class="wc-sb-card-meta">{{ tpl.duration }} Min.</div>
          </div>
          <v-icon v-if="!editMode" x-small class="wc-sb-card-drag">mdi-drag-variant</v-icon>
        </div>
      </div>

      <div class="wc-sb-section mb-8" v-if="customAppointmentTemplates.length > 0">
        <div class="text-overline mb-3 letter-spacing-1 px-1" style="color: #42a5f5; opacity: 0.8">Eigene Vorlagen</div>
        <div
          v-for="tpl in customAppointmentTemplates"
          :key="tpl._id || tpl.id"
          class="wc-sb-card mb-2"
          :style="{ '--card-color': tpl.color || '#2196F3' }"
          :draggable="!editMode"
          @dragstart="!editMode && onDragStart($event, tpl)"
          @dragend="dragging = null"
          @click="!editMode && $emit('template-click', tpl)">
          <div class="wc-sb-card-icon">
            <v-icon small color="white">{{ tpl.icon || "mdi-calendar" }}</v-icon>
          </div>
          <div class="wc-sb-card-content">
            <div class="wc-sb-card-title">{{ tpl.title }}</div>
            <div class="wc-sb-card-meta">{{ tpl.duration }} Min.</div>
          </div>
          <v-icon v-if="!editMode" x-small class="wc-sb-card-drag">mdi-drag-variant</v-icon>
          <div v-if="editMode" class="d-flex" style="gap: 2px">
            <v-btn icon small color="blue lighten-1" @click.stop="$emit('edit-template', tpl)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small color="red lighten-1" @click.stop="$emit('delete-template', tpl._id || tpl.id)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </div>
        </div>
      </div>

      <!-- TAB 3: UNBETREUT -->
      <div v-show="activeTab === 3">
        <div class="wc-sb-section mb-8 mt-4" v-if="unsupervisedTemplates.length > 0">
          <div class="text-overline mb-3 letter-spacing-1 px-1" style="color: #9C27B0; opacity: 0.8">Unbetreut Vorlagen</div>
          <div v-for="tpl in unsupervisedTemplates" :key="tpl._id || tpl.id" class="wc-sb-card mb-2" :style="{ '--card-color': tpl.color || '#9C27B0', cursor: 'pointer' }" :draggable="!editMode" @dragstart="!editMode && onDragStart($event, tpl)" @dragend="dragging = null">
            <div class="wc-sb-card-icon"><v-icon small color="white">{{ tpl.icon || 'mdi-account-clock' }}</v-icon></div>
            <div class="wc-sb-card-content">
              <div class="wc-sb-card-title">{{ tpl.title }}</div>
              <div class="wc-sb-card-meta">Unbetreut</div>
            </div>
            <v-icon v-if="!editMode" x-small class="wc-sb-card-drag">mdi-drag-variant</v-icon>
            <div v-if="editMode" class="d-flex" style="gap: 2px">
              <v-btn icon small color="blue lighten-1" @click.stop="$emit('edit-template', tpl)"><v-icon small>mdi-pencil</v-icon></v-btn>
              <v-btn icon small color="red lighten-1" @click.stop="$emit('delete-template', tpl._id || tpl.id)"><v-icon small>mdi-delete</v-icon></v-btn>
            </div>
          </div>
        </div>
        <div v-else class="text-center mt-10 opacity-40">
          <v-icon large class="mb-3" color="rgba(255,255,255,0.3)">mdi-account-clock</v-icon>
          <div style="font-size: 0.85rem">Keine unbetreut Vorlagen.</div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkCalendarSidebar",
  // 1. Props wiederhergestellt, um eigene Vorlagen zu empfangen
  props: {
    templates: { type: Array, default: () => [] },
    dailyTasks: { type: Array, default: () => [] },
    completions: { type: Array, default: () => [] },
  },
  data() {
    return {
      editMode: false,
      dragging: null,
      activeTab: 2, // Start with "Termin" tab by default since it's used most often

      trainingTemplates: [
        {
          id: "w1",
          title: "Probetraining",
          icon: "mdi-account-star",
          color: "#F57C00",
          duration: 60,
          type: "appointment",
          specialType: "trial",
          requiresCustomer: true,
        },
        {
          id: "w2",
          title: "Einführungstraining",
          icon: "mdi-dumbbell",
          color: "#1976D2",
          duration: 60,
          type: "appointment",
          specialType: "workout",
          requiresCustomer: true,
        },
        {
          id: "w2b",
          title: "Ergänzungstraining",
          icon: "mdi-dumbbell",
          color: "#1565C0",
          duration: 30,
          type: "appointment",
          specialType: "workout",
          requiresCustomer: true,
        },
        {
          id: "w2c",
          title: "Personal Training",
          icon: "mdi-run",
          color: "#0D47A1",
          duration: 60,
          type: "appointment",
          specialType: "workout",
          requiresCustomer: true,
        },
        {
          id: "w3",
          title: "Anamnese / Checkup",
          icon: "mdi-clipboard-pulse",
          color: "#00ACC1",
          duration: 30,
          type: "appointment",
          specialType: "anamnese",
          requiresCustomer: true,
        },
      ],
      contractTemplates: [
        {
          id: "a1",
          title: "Vertrag erstellen",
          icon: "mdi-file-document-edit",
          color: "#37474F",
          duration: 30,
          type: "appointment",
          specialType: "new_contract",
          requiresCustomer: false,
        },
        {
          id: "a2",
          title: "Upgrade / Anpassung",
          icon: "mdi-star-circle",
          color: "#455A64",
          duration: 30,
          type: "appointment",
          specialType: "upgrade",
          requiresCustomer: true,
        },
      ],
      standardAppointmentTemplates: [
        { id: "ap1", title: "Termin (Standard)", icon: "mdi-calendar", color: "#00963f", duration: 60, type: "appointment", requiresCustomer: true },
        { id: "ap2", title: "Kurzer Termin", icon: "mdi-clock-fast", color: "#00963f", duration: 15, type: "appointment", requiresCustomer: true },
      ],
    }
  },
  computed: {
    customAppointmentTemplates() {
      return this.templates.filter((t) => t.category === "termin" || (!t.category && t.type === "appointment"))
    },
    customTaskTemplates() { // Alle Ämtli
      return this.templates.filter((t) => t.category === "ämtli" || (!t.category && t.type === "task"))
    },
    // Ämtli nach Frequenz aufteilen
    dailyTaskTemplates() {
      return this.customTaskTemplates.filter((t) => !t.frequency || t.frequency === "daily")
    },
    weeklyTaskTemplates() {
      return this.customTaskTemplates.filter((t) => t.frequency === "weekly")
    },
    monthlyTaskTemplates() {
      return this.customTaskTemplates.filter((t) => t.frequency === "monthly")
    },
    taskTemplates() { // Aufgabe
      return this.templates.filter((t) => t.category === "aufgabe")
    },
    unsupervisedTemplates() { // Unbetreut
      return this.templates.filter((t) => t.category === "unbetreut")
    },
  },
  methods: {
    getTaskCountInfo(tpl, frequency) {
      if (!this.completions) return { current: 0, target: tpl.targetCount || 1 }
      const templateCompletions = this.completions.filter(c => String(c.template) === String(tpl._id || tpl.id))
      const now = this.$moment()
      let current = 0
      if (frequency === 'weekly') {
        current = templateCompletions.filter(c => this.$moment(c.date).isSame(now, 'isoWeek')).length
      } else if (frequency === 'monthly') {
        current = templateCompletions.filter(c => this.$moment(c.date).isSame(now, 'month')).length
      }
      return { current, target: tpl.targetCount || 1 }
    },
    getTaskCountString(tpl, frequency) {
      const { current, target } = this.getTaskCountInfo(tpl, frequency)
      if (target <= 1) return frequency === 'weekly' ? 'Diese Woche' : 'Diesen Monat'
      return `${current} / ${target} geplant`
    },
    isTaskDone(tpl) {
      const { current, target } = this.getTaskCountInfo(tpl, tpl.frequency)
      return current >= target
    },
    toggleTaskCompletion(tpl) {
      if (this.isTaskDone(tpl)) {
        // Find completion id to delete
        const templateCompletions = this.completions.filter(c => String(c.template) === String(tpl._id || tpl.id))
        const now = this.$moment()
        let toDelete = null
        if (tpl.frequency === 'weekly') {
          toDelete = templateCompletions.find(c => this.$moment(c.date).isSame(now, 'isoWeek'))
        } else if (tpl.frequency === 'monthly') {
          toDelete = templateCompletions.find(c => this.$moment(c.date).isSame(now, 'month'))
        }
        if (toDelete) {
          this.$emit('unmark-done', toDelete._id)
        }
      } else {
        // Erstellen
        this.$emit('mark-done', { templateId: tpl._id || tpl.id, date: this.$moment().format('YYYY-MM-DD') })
      }
    },
    onDragStart(e, tpl) {
      this.dragging = tpl.id || tpl._id
      const dragObj = { ...tpl, create: true }

      e.dataTransfer.setData("templateObj", JSON.stringify(dragObj))
      e.dataTransfer.effectAllowed = "copy"

      this.$emit("drag-start", dragObj)

      const dragIcon = e.target.querySelector(".wc-sb-card-icon")
      if (dragIcon) {
        e.dataTransfer.setDragImage(dragIcon, 16, 16)
      }
    },
  },
}
</script>

<style scoped>
.wc-sidebar {
  overflow: auto;
  background: var(--bg-sidebar);
  border-left: 1px solid var(--border-light);
}

.wc-sb-header {
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-bottom: 1px solid var(--border-light);
  background: var(--bg-panel);
}
.wc-sb-icon-box {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: linear-gradient(135deg, #4caf50, #2e7d32);
  display: flex;
  align-items: center;
  justify-content: center;
}
.wc-sb-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-main);
}
.wc-sb-add {
  color: var(--icon-muted) !important;
  background: rgba(128, 128, 128, 0.1) !important;
  transition: all 0.2s;
}
.wc-sb-add:hover {
  color: #66bb6a !important;
  background: rgba(76, 175, 80, 0.15) !important;
}

.wc-sb-tabs-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  background: var(--bg-panel);
  border-radius: 12px;
  padding: 4px;
  border: 1px solid var(--border-light);
}
.wc-sb-tab {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.wc-sb-tab.active {
  background: var(--bg-card);
  color: var(--text-main);
  box-shadow: var(--shadow-color) 0px 2px 8px;
}
.wc-sb-tab i {
  color: inherit !important;
}

.letter-spacing-1 {
  letter-spacing: 1px !important;
}
.wc-sb-card {
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: 12px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: grab;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  user-select: none;
}
.wc-sb-card:hover {
  transform: translateY(-2px);
  border-color: var(--card-color);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.wc-sb-card:active {
  cursor: grabbing;
}
.wc-sb-card-nodrag {
  cursor: pointer !important;
}
.wc-sb-card-nodrag:active {
  cursor: pointer !important;
  transform: scale(0.98);
}
.wc-sb-card-highlight {
  border-left: 3px solid #66bb6a;
  background: rgba(102, 187, 106, 0.05);
}
.wc-sb-card-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--card-color);
  flex-shrink: 0;
}
.wc-sb-card-content {
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
}
.wc-sb-card-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-main);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wc-sb-card-meta {
  font-size: 0.7rem;
  color: var(--text-disabled);
}
.wc-sb-card-drag {
  color: var(--text-disabled);
  opacity: 0.3;
}

/* Scrollbar */
.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: var(--border-medium);
  border-radius: 3px;
}

/* Premium Tabs Sidebar */
.wc-sb-premium-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}
.wc-sb-tab {
  flex: 1 1 calc(50% - 6px);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 12px;
  cursor: pointer;
  background: transparent;
  border: 1px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-tap-highlight-color: transparent;
}
@media (hover: hover) {
  .wc-sb-tab:hover:not(.active) {
    background: rgba(255, 255, 255, 0.04);
  }
}
.wc-sb-tab.active {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03));
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.wc-sb-tab-icon {
  color: rgba(255, 255, 255, 0.3) !important;
  transition: all 0.3s ease;
}
.wc-sb-tab.active .wc-sb-tab-icon {
  color: #fff !important;
  transform: scale(1.1);
}
.wc-sb-tab-text {
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
  transition: all 0.3s ease;
}
.wc-sb-tab.active .wc-sb-tab-text {
  color: #fff;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
}
</style>
